var $d0049f7728802ad2$exports = {};
/**
 * Copyright © RINIS 2026
 * Licensed under the EUPL
 */ $d0049f7728802ad2$var$enablePropertiesTemplates();
document.body.addEventListener('htmx:afterSettle', function() {
    $d0049f7728802ad2$var$enablePropertiesTemplates();
});
function $d0049f7728802ad2$var$enablePropertiesTemplates() {
    document.querySelectorAll('[data-properties-template-name]').forEach((el)=>{
        // first remove the listener in case it was added in a previous HTML request
        el.removeEventListener('click', $d0049f7728802ad2$var$onClickHandler);
        el.addEventListener('click', $d0049f7728802ad2$var$onClickHandler);
    });
}
function $d0049f7728802ad2$var$onClickHandler(event) {
    event.preventDefault();
    const templateName = event.target.dataset.propertiesTemplateName;
    let template = "";
    switch(templateName){
        case "delegation-connection-external-contract":
            template = $d0049f7728802ad2$var$templateDelegationConnection;
            break;
        case "delegation-publication-external-contract":
            template = $d0049f7728802ad2$var$templateDelegationPublication;
            break;
        case "verantwoording":
            template = $d0049f7728802ad2$var$templateVerantwoording;
            break;
        default:
            console.log(`unknown template name '${templateName}'`);
    }
    const targetID = event.target.dataset.propertiesTemplateTargetId;
    document.getElementById(targetID).value = template;
}
const $d0049f7728802ad2$var$templateDelegationConnection = `{
  "delegation.connection.external_contract_reference": {
    "delegator_id": "",
    "delegator_name": "",
    "reference": ""
  }
}`;
const $d0049f7728802ad2$var$templateDelegationPublication = `{
  "delegation.publication.external_contract_reference": {
    "delegator_id": "",
    "delegator_name": "",
    "reference": ""
  }
}`;
const $d0049f7728802ad2$var$templateVerantwoording = `{
  "verantwoording": {
    "wettelijke_grondslag": "",
    "verwerkingsrelatie": "",
    "kanaal": ""
  }
}`;


//# sourceMappingURL=controller.2807f268.js.map
